import AffiliatesTable from '@/components/affiliate/table/Affiliates.Table';
import { PageHeader } from '@/components/ui';
import { usePageTitleStore } from '@/stores/page-title';
import { Container } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * Affiliates list. The former Affiliates/Invitations tab bar is gone — the two
 * views are now separate routes reached from the sidebar's Affiliation group.
 * Legacy `?tab=` deep links are redirected to the matching route.
 */
const AffiliatesPage = () => {
  const { t } = useTranslation();
  const setTitle = usePageTitleStore((state) => state.setTitle);
  const [searchParams] = useSearchParams();
  const legacyTab = searchParams.get('tab');

  useEffect(() => {
    setTitle(t('affiliates.title'));
    return () => setTitle(null);
  }, [setTitle, t]);

  if (legacyTab === 'invitations' || legacyTab === 'affiliates') {
    // Preserve every other query param (search, filters...) across the redirect.
    const rest = new URLSearchParams(searchParams);
    rest.delete('tab');
    const search = rest.toString();
    return (
      <Navigate
        to={{
          pathname: legacyTab === 'invitations' ? '/affiliates/invitations' : '/affiliates',
          search: search ? `?${search}` : '',
        }}
        replace
      />
    );
  }

  return (
    <Container maxW="full" py={{ base: 5, xl: 6 }} px={{ base: 4, xl: 6 }}>
      <PageHeader title={t('affiliates.title')} description={t('affiliates.description')} />
      <AffiliatesTable />
    </Container>
  );
};

export default AffiliatesPage;
